/**
 * ResultsView — summary stats + download button shown after job completes.
 */

import React from 'react';
import { JobStatusResponse, CATEGORY_COLORS, CATEGORY_LABELS, PhoneCategory } from '../types';
import { downloadApi } from '../services/api';

interface Props {
  jobId: string;
  status: JobStatusResponse;
}

export const ResultsView: React.FC<Props> = ({ jobId, status }) => {
  const total = status.total_numbers;
  const counts = status.category_counts;

  const handleDownload = () => {
    const filename = (status as any).filename || `job-${jobId}.xlsx`;
    downloadApi.triggerDownload(jobId, filename);
  };

  return (
    <div style={{ padding: 24 }}>
      <h3 style={{ marginTop: 0, color: 'var(--text-strong)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Run Complete</h3>
      <p style={{ color: 'var(--text-soft)' }}>
        {status.processed_count} of {total} numbers processed.
      </p>

      {/* Category breakdown */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
        {Object.entries(counts)
          .sort(([, a], [, b]) => b - a)
          .map(([cat, count]) => {
            const pct = total > 0 ? Math.round((count / total) * 100) : 0;
            return (
              <div key={cat} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ width: 120, fontSize: 13, color: 'var(--text)' }}>
                  {CATEGORY_LABELS[cat as PhoneCategory] || cat}
                </div>
                <div style={{ flex: 1, background: 'var(--status-neutral-bg)', borderRadius: 6, height: 20, overflow: 'hidden' }}>
                  <div
                    style={{
                      height: '100%', width: `${pct}%`,
                      background: CATEGORY_COLORS[cat as PhoneCategory] || 'var(--status-neutral-bg)',
                      minWidth: pct > 0 ? 4 : 0,
                    }}
                  />
                </div>
                <span style={{ width: 60, fontSize: 13, color: 'var(--text-soft)', textAlign: 'right' }}>
                  {count} ({pct}%)
                </span>
              </div>
            );
          })}
      </div>

      <button
        onClick={handleDownload}
        style={{
          background: 'linear-gradient(135deg, #8a2000, #5c0000)', color: 'var(--text)', border: '2px solid var(--teal)',
          padding: '12px 28px', borderRadius: 8, fontSize: 15,
          fontWeight: 600, cursor: 'pointer',
        }}
      >
        ⬇️ Download Results (.xlsx)
      </button>
      <p style={{ fontSize: 12, color: 'var(--text-faint)', marginTop: 8 }}>
        Status columns are inserted immediately after each phone column.
        Multi-number cells use <code>; </code> as delimiter.
      </p>
    </div>
  );
};
